"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_remove-membership.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OPTIONS = [{
  value: 'DELETE',
  label: 'This user might lose access to some resources and projects'
}];

var RemoveMembershipModal = /*#__PURE__*/function (_Component) {
  _inherits(RemoveMembershipModal, _Component);

  function RemoveMembershipModal() {
    var _this;

    _classCallCheck(this, RemoveMembershipModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RemoveMembershipModal).call(this));

    _defineProperty(_assertThisInitialized(_this), "onOptionCheck", (0, _lodash.default)(function (value) {
      return function () {
        _this.setState(function (_ref) {
          var options = _ref.options;
          return {
            options: _objectSpread({}, options, _defineProperty({}, value, !options[value]))
          };
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "resetState", function () {
      _this.setState(_this.getInitialState());
    });

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, deleteTeamMembershipApi, onClose, membership, onMembershipDeleted, _ref3, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, deleteTeamMembershipApi = _this$props.deleteTeamMembershipApi, onClose = _this$props.onClose, membership = _this$props.membership, onMembershipDeleted = _this$props.onMembershipDeleted;

              if (!(!membership || !membership.teamMembershipId)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.next = 5;
              return deleteTeamMembershipApi({
                teamMembershipId: membership.teamMembershipId
              });

            case 5:
              _ref3 = _context.sent;
              error = _ref3.error;

              if (!error) {
                onMembershipDeleted();
                onClose();
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(RemoveMembershipModal, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        options: OPTIONS.reduce(function (result, option) {
          return _objectSpread({}, result, _defineProperty({}, option.value, false));
        }, {})
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref4) {
      var prevVisible = _ref4.visible;
      var visible = this.props.visible;
      var isModalOpening = visible && !prevVisible;

      if (!isModalOpening) {
        return;
      }

      this.resetState();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          visible = _this$props2.visible,
          onClose = _this$props2.onClose,
          teamName = _this$props2.teamName,
          _this$props2$membersh = _this$props2.membership;
      _this$props2$membersh = _this$props2$membersh === void 0 ? {} : _this$props2$membersh;
      var user = _this$props2$membersh.user;
      var options = this.state.options;
      var title = "Remove ".concat((0, _getUserFullName.default)(user));
      var subtitle = "Team ".concat(teamName);
      return _react.default.createElement("div", {
        className: "remove-membership"
      }, _react.default.createElement(_uiKit.FormModal, {
        title: title,
        subtitle: subtitle,
        visible: visible,
        onClose: onClose,
        onSave: this.handleSave,
        saveText: "YES, REMOVE USER",
        saveDisabled: !Object.values(options).every(Boolean),
        stayOpenOnSave: true
      }, _react.default.createElement("p", {
        className: "remove-membership__warning"
      }, "Warning:  This action cannot be undone"), OPTIONS.map(function (_ref5) {
        var value = _ref5.value,
            label = _ref5.label;
        return _react.default.createElement(_uiKit.Checkbox, {
          key: value,
          className: "remove-membership__checkbox",
          checked: options[value],
          onChange: _this2.onOptionCheck(value)
        }, label);
      })));
    }
  }]);

  return RemoveMembershipModal;
}(_react.Component);

var _default = RemoveMembershipModal;
exports.default = _default;